/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnablingServiceGroupResponse } from '../../models/enabling-service-group-response';
import { EnablingServiceType } from '../../models/enabling-service-type';

export interface GetEnablingServices$Params {
  serviceType: EnablingServiceType;
}

export function getEnablingServices(http: HttpClient, rootUrl: string, params: GetEnablingServices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnablingServiceGroupResponse>>> {
  const rb = new RequestBuilder(rootUrl, getEnablingServices.PATH, 'get');
  if (params) {
    rb.path('serviceType', params.serviceType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EnablingServiceGroupResponse>>;
    })
  );
}

getEnablingServices.PATH = '/api/ambassador-enabling-services/{serviceType}';
